import { useUser } from '../context/UserContext';
import { Navigate } from 'react-router-dom';

const AdminRoute = ({ children }) => {
  const { user, userData, loading } = useUser();
  
  // ⚠️ SUBSTITUA pelo seu email real
  const adminEmails = ['chfernan12@gmail.com']; // seu email aqui

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Carregando...</span>
        </div>
      </div>
    );
  }

  // logs para depuração do fluxo administrativo
  console.log('AdminRoute - user:', user?.email);
  console.log('AdminRoute - userData:', userData);
  console.log('AdminRoute - admin check:', adminEmails.includes(user?.email));
  console.log('AdminRoute - active check:', userData?.active !== false);

  // Verifica se o usuário está logado, é admin e está ativo
  if (!user || !adminEmails.includes(user.email) || userData?.active === false) {
    return <Navigate to="/home" replace />;
  }

  return children;
};

export default AdminRoute;